import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { AiFillSetting } from "react-icons/ai";
import { BsFillPatchQuestionFill } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import FileField from "../../../upload/FileField";
import { uuid } from "short-uuid";

import {
  MdAlignHorizontalCenter,
  MdAlignHorizontalLeft,
  MdAlignHorizontalRight,
  MdDelete,
  MdOutlineAlignVerticalBottom,
} from "react-icons/md";
import ColorPicker from "./Scrabble/ColorPicker";
import { Skeleton } from "antd";

import QRCodeStyling from "qr-code-styling";
import { debounce, get, pick } from "lodash";
import { ASSET_URL, AWS_API } from "../../../../config";
import axios from "axios";
import { uniqueID } from "../../Utilities/helper";
import { ARTWORK } from "../../../../types";
import { FaFileExport, FaFileImport, FaPlus } from "react-icons/fa";

function getNestedValue(obj, path) {
  return path.reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
    obj
  );
}

const normalizeColorStops = (config) => {
  const GRADIENT_PATHS = [
    ["dotsOptions", "gradient"],
    ["cornersSquareOptions", "gradient"],
    ["cornersDotOptions", "gradient"],
    ["backgroundOptions", "gradient"],
  ];

  for (const path of GRADIENT_PATHS) {
    const gradient = getNestedValue(config, path);

    if (
      gradient &&
      gradient.colorStops &&
      !Array.isArray(gradient.colorStops)
    ) {
      gradient.colorStops = Object.keys(gradient.colorStops)
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => gradient.colorStops[key]);
    }
  }

  return config;
};

const PreviewQRListItem = ({
  config,
  defaultConfigId,
  onChangeID,
  onDeleteConfig,
}) => {
  const [img, setImg] = useState(null);

  const renderImage = () => {
    const radio = 100 / (Number(config?.width) || 4000);
    const cf = normalizeColorStops({...config});
    
    const qrCode = new QRCodeStyling({
      ...cf,
      width: cf?.width * radio,
      height: cf?.height * radio,
      margin: cf?.margin * radio,
    });
    
    if(cf?.shape == "circle"){
      qrCode.applyExtension(window.QRBorderPlugin({
        ...cf.borderRadius,
        thickness: cf?.borderRadius?.thickness * radio,
        dasharray: cf?.borderRadius?.dasharray * radio,
      }));
    }
    qrCode.getRawData("png").then((blob) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64data = reader.result;
        setImg(base64data);
      };
      reader.readAsDataURL(blob);
    });
  };
  useEffect(() => {
    renderImage();
  }, []);
  useEffect(() => {
    renderImage();
  }, [config]);
  return (
    <div
      style={{
        cursor: "pointer",
        borderRadius: 5,
        marginRight: 5,
        position: "relative",
        padding: defaultConfigId == config?.id ? 5 : 0,
      }}
    >
      {img && (
        <img
          onClick={() => onChangeID(config.id)}
          style={{
            width: 80,
            border: defaultConfigId == config?.id ? "2px solid red" : "",
            borderRadius: 5,
            overflow: "hidden",
            cursor: "pointer",
            transition: "0.7s",
          }}
          src={img}
        />
      )}
      <div>
        <Popconfirm
          placement="topLeft"
          title={"Are you sure to delete this"}
          onConfirm={() => onDeleteConfig(config.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            style={{
              position: "absolute",
              top: 0,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              right: 0,
              background: "red",
              color: "#fff",
              border: "none",
              outline: "none",
              cursor: "pointer",
            }}
            icon={<MdDelete />}
          ></Button>
        </Popconfirm>
      </div>
    </div>
  );
};

const FormQRSetting = ({ layer }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingApply, setLoadingApply] = useState(false);
  const [imageURL, setImageURL] = useState("");
  const [form] = Form.useForm();
  const [defaultConfigId, setDefaultConfigId] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);
  const [QRListStyle, setQRListStyle] = useState([]);
  const [configs, setConfigs] = useState({});
  const [openExport, setOpenExport] = useState(false);
  const [openImport, setOpenImport] = useState(false);
  const [valueImport, setValueImport] = useState("");

  const { TextArea } = Input;

  useEffect(() => {
    setQRListStyle((prev) => [...(layer?.QRListStyle || [])]);
    setDefaultConfigId(layer?.defaultConfigId);
  }, []);

  useEffect(() => {
    // form.setFieldsValue({ ...configs });
    setLoadingForm(true);

    const findConfig = QRListStyle.find((i) => i.id == defaultConfigId);
    if (findConfig) {
      form.setFieldsValue({ ...findConfig });
      handleRender({ ...findConfig }, defaultConfigId);
    }

    setTimeout(() => {
      setLoadingForm(false);
    }, 300);
  }, [defaultConfigId]);
  const showModel = () => {
    setOpen(true);
  };
  const closeModel = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();

  const OnClickSaveSetting = () => {
    const values = form.getFieldsValue();
    dispatch({
      type: ARTWORK.SET_LAYER,
      payload: {
        ...layer,
        QRListStyle: [...QRListStyle],
        defaultConfigId: defaultConfigId,
      },
    });
    closeModel();
  };

  const handleImport = () => {
    try {
      if (
        !(
          valueImport &&
          Array.isArray(JSON.parse(valueImport)) &&
          JSON.parse(valueImport).length > 0
        )
      ) {
        message.error("Import failed!");
        return;
      }
      setQRListStyle((prev) => [
        ...prev,
        ...JSON.parse(valueImport).map((i) => {
          return {
            ...i,
            id: uuid(),
          };
        }),
      ]);
      setValueImport("");
      message.success("Import successfully!");
    } catch (error) {
      message.error("Import failed!");
      return;
    }
  };

  const handleForm = useCallback(
    debounce((vaue, id) => {
      handleRender(null, id);
    }, 1000),
    []
  );

  const handleRender = (configs = null, defaultConfigId) => {
    setLoading(true);
    let options = configs ? configs : form.getFieldsValue();
    setQRListStyle((prev) => {
      const newData = [...prev].map((e) => {
        if (e.id == defaultConfigId) {
          return {
            ...e,
            ...options,
          };
        }
        return e;
      });
      return [...newData];
    });

    const reoptions = normalizeColorStops(options);
    const qrCode = new QRCodeStyling(reoptions);

    if(options?.shape == "circle"){
      qrCode.applyExtension(window.QRBorderPlugin(options.borderRadius));
    }
    

    qrCode.getRawData("png").then((blob) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64data = reader.result;
        setImageURL(base64data);
        setLoading(false);
      };
      reader.readAsDataURL(blob);
    });
  };

  const getSignedUrl = async (mime) => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    var signedUrl = null;
    await fetch(`${AWS_API}/signedUrl?type=${mime}`, requestOptions)
      .then((response) => response.json())
      .then((res) => (signedUrl = res))
      .catch((err) => console.error(err));
    return signedUrl;
  };

  const handleAddStyle = () => {
    const values = form.getFieldsValue();
    const uniqueID = uuid();
    setQRListStyle((prev) => [
      ...prev,
      {
        id: uniqueID,
        ...values,
      },
    ]);
    setDefaultConfigId(uniqueID);
    message.success("Bạn đã thêm một stype mới thành công.");
  };

  const upload = async (base64) => {
    var file = await fetch(base64)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
    var signedUrl = await getSignedUrl(file.type);
    await axios
      .put(signedUrl.url, file, {
        headers: {
          "Content-Type": file.type,
        },
      })
      .catch((err) => console.error(err));
    return {
      id: uniqueID(),
      key: signedUrl.key,
    };
  };

  function getImageDimensions(base64Image) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const dimensions = {
          width: img.naturalWidth,
          height: img.naturalHeight,
        };
        resolve(dimensions);
      };

      img.onerror = () => {
        reject(new Error("Failed to load image."));
      };

      img.src = base64Image;
    });
  }

  const onDeleteConfig = (id) => {
    const newQRList = QRListStyle.filter((i) => i.id != id);
    if (newQRList.length <= 0) {
      message.error("Cannot be deleted!");
      return;
    }
    setQRListStyle((prev) => {
      return [...newQRList];
    });
    if (defaultConfigId == id) {
      setDefaultConfigId(newQRList[0]?.id);
    }
  };

  const handleApply = async () => {
    if (imageURL.indexOf("base64") >= 0) {
      setLoadingApply(true);
      const upfile = await upload(imageURL);
      const configsQR = form.getFieldsValue();
      const width = layer.width;

      const getSizeImage = await getImageDimensions(ASSET_URL + upfile.key);
      const scaleImg = width / getSizeImage.width;

      const valuesLayer = get(layer, "values", []);
      valuesLayer[0].file = pick(upfile, ["id", "key"]);

      dispatch({
        type: ARTWORK.SET_LAYER,
        payload: {
          ...layer,
          values: valuesLayer,
          QRListStyle: [...QRListStyle],
          defaultConfigId: defaultConfigId,
          width: getSizeImage.width * scaleImg,
          height: getSizeImage.height * scaleImg,
        },
      });

      closeModel();
      setLoadingApply(false);
    }
  };
  const colorType = Form.useWatch(["dotsOptions", "colorType"], form);
  const stanColorType = form.getFieldValue("dotsOptions")?.colorType;

  const cornersSquareOptionsColorType = Form.useWatch(
    ["cornersSquareOptions", "colorType"],
    form
  );
  const cornersSquareOptionsStanColorType = form.getFieldValue(
    "cornersSquareOptions"
  )?.colorType;

  const cornersDotOptionsColorType = Form.useWatch(
    ["cornersDotOptions", "colorType"],
    form
  );
  const cornersDotOptionsStanColorType =
    form.getFieldValue("cornersDotOptions")?.colorType;

  const backgroundOptionsColorType = Form.useWatch(
    ["backgroundOptions", "colorType"],
    form
  );
  const backgroundOptionsStanColorType =
    form.getFieldValue("backgroundOptions")?.colorType;

  const shapeWatch = Form.useWatch(["shape"], form);
  const shapeField = form.getFieldValue("shape");

  useEffect(() => {
    if (backgroundOptionsColorType == "transparent") {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        backgroundOptions: {
          ...form.getFieldsValue().backgroundOptions,
          color: "#ffffff00",
        },
      });
    } else {
      form.setFieldsValue({
        "backgroundOptions.color": "#ffffff00",
      });
    }
  }, [backgroundOptionsColorType]);
  return (
    <div>
      <Modal
        title="Settings"
        centered
        visible={open}
        onOk={OnClickSaveSetting}
        onCancel={closeModel}
        footer={[
          <Space key="10">
            <Button
              key={1}
              onClick={closeModel}
              style={{
                borderRadius: 3,
              }}
            >
              Cancel
            </Button>
            <Button
              key={3}
              type="primary"
              onClick={OnClickSaveSetting}
              style={{
                borderRadius: 3,
              }}
            >
              Save settings
            </Button>
          </Space>,
        ]}
        width={1111}
        okText={"Save settings"}
        className={"modal_setting modal_setting_crossword"}
      >
        <div className={"body_modal_setting"}>
          <div
            style={{
              height: "100%",
              overflow: "auto",
            }}
            className={"body_modal_setting_item1"}
          >
            <div
              style={{
                width: "100%",
                background: "#f2f2f2",
                padding: "10px",
                position: "sticky",
                top: 0,
                zIndex: 999999,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Space>
                <Button onClick={handleAddStyle}>
                  <FaPlus /> Add type
                </Button>
                <Button
                  loading={loading}
                  onClick={() => handleRender(null, defaultConfigId)}
                  style={{
                    borderRadius: 3,
                  }}
                >
                  Render - Check Setting
                </Button>
                {imageURL && (
                  <Button
                    type="primary"
                    loading={loadingApply || loading}
                    onClick={handleApply}
                    style={{
                      borderRadius: 3,
                    }}
                  >
                    Apply and Save settings
                  </Button>
                )}
              </Space>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                marginTop: 10,
              }}
            >
              <strong
                style={{
                  width: "100%",
                  paddingLeft: 10,
                  fontSize: 17,
                  display: "block",
                }}
              >
                Styles:
              </strong>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{
                    marginRight: 5,
                  }}
                  onClick={() => {
                    setOpenImport(true);
                  }}
                >
                  <FaFileImport
                    style={{
                      marginRight: 5,
                    }}
                  />{" "}
                  Import
                </Button>
                <Button onClick={() => setOpenExport(true)}>
                  <FaFileExport
                    style={{
                      marginRight: 5,
                    }}
                  />{" "}
                  Export
                </Button>
              </div>
            </div>
            <Modal
              title="Export Json Style"
              centered
              visible={openExport}
              onOk={() => setOpenExport(false)}
              onCancel={() => setOpenExport(false)}
              footer={[
                <Space key="10">
                  <Button
                    key={1}
                    onClick={() => setOpenExport(false)}
                    style={{
                      borderRadius: 3,
                    }}
                  >
                    OK
                  </Button>
                  <CopyToClipboard
                    text={JSON.stringify(QRListStyle)}
                    onCopy={() => message.success("Copied to clipboard")}
                  >
                    <Button>Copy</Button>
                  </CopyToClipboard>
                </Space>,
              ]}
              width={600}
              okText={"Save settings"}
            >
              <TextArea
                cols={50}
                rows={10}
                style={{
                  minHeight: "200px",
                }}
                readOnly
                value={JSON.stringify(QRListStyle, null, 2)}
              />
            </Modal>

            {/* Import */}
            <Modal
              title="Import json style"
              centered
              visible={openImport}
              onOk={handleImport}
              onCancel={() => setOpenImport(false)}
              footer={[
                <Space key="10">
                  <Button
                    key={1}
                    onClick={() => setOpenImport(false)}
                    style={{
                      borderRadius: 3,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button disabled={!valueImport} onClick={handleImport}>
                    OK
                  </Button>
                </Space>,
              ]}
              width={600}
              okText={"Save settings"}
            >
              <TextArea
                cols={50}
                rows={10}
                style={{
                  minHeight: "200px",
                }}
                onChange={(e) => setValueImport(e.target.value)}
                value={valueImport}
              />
            </Modal>

            <div
              style={{
                display: "flex",
                overflowX: "auto",
                overflowY: "hidden",
                padding: "5px 10px",
                alignItems: "center",
                justifyContent: "flexStart",
              }}
            >
              {QRListStyle.map((i, index_) => {
                return (
                  <PreviewQRListItem
                    onDeleteConfig={onDeleteConfig}
                    config={i}
                    key={index_}
                    defaultConfigId={defaultConfigId}
                    onChangeID={setDefaultConfigId}
                  />
                );
              })}
            </div>
            {!loadingForm && (
              <Form
                layout="vertical"
                form={form}
                onValuesChange={(v) => handleForm(v, defaultConfigId)}
              >
                <Form.Item
                  style={{
                    display: "none",
                  }}
                  initialValue="#ffffff"
                  label="Color Type"
                  name={["backgroundOptions", "color"]}
                >
                  <Input value="#ffffff" />
                </Form.Item>
                <Form.Item
                  style={{
                    display: "none",
                  }}
                  initialValue="4000"
                  name={["width"]}
                >
                  <Input value="4000" />
                </Form.Item>
                <Form.Item
                  style={{
                    display: "none",
                  }}
                  initialValue="4000"
                  name={["height"]}
                >
                  <Input value="4000" />
                </Form.Item>
                <Card
                  className="card-settingt-srabble"
                  title={<strong>Main Options</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    {/* data  */}
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <h4
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <span>Data</span>
                      </h4>
                      <div>
                        <Form.Item
                          initialValue="MY QR"
                          className="calendar-layer-choose-image"
                          name={["data"]}
                        >
                          <TextArea rows={4} />
                        </Form.Item>
                      </div>
                    </Col>

                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="20"
                        label="Margin"
                        name={["margin"]}
                      >
                        <InputNumber
                          style={{
                            width: "100%",
                          }}
                          min={0}
                          step={1}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                <Card
                  className="card-settingt-srabble"
                  title={<strong>Background Options</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="single-color"
                        label="Color Type"
                        name={["backgroundOptions", "colorType"]}
                      >
                        <Radio.Group
                          defaultValue={"single-color"}
                          optionType="button"
                          buttonStyle="solid"
                        >
                          <Radio.Button value="transparent">
                            Transparent
                          </Radio.Button>
                          <Radio.Button value="single-color">
                            Single color
                          </Radio.Button>
                          <Radio.Button value="color-gradient">
                            Color gradient
                          </Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {(backgroundOptionsColorType === "transparent" ||
                      backgroundOptionsStanColorType == "transparent") && (
                      <Col
                        span={8}
                        style={{
                          paddingRight: 5,
                          overflow: "hidden",
                          display: "none",
                        }}
                      >
                        <Form.Item
                          initialValue="#ffffff00"
                          label="Color"
                          name={["backgroundOptions", "color"]}
                        >
                          <ColorPicker
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {(backgroundOptionsColorType === "single-color" ||
                      backgroundOptionsStanColorType == "single-color") && (
                      <Col
                        span={8}
                        style={{
                          paddingRight: 5,
                          overflow: "hidden",
                        }}
                      >
                        <Form.Item
                          initialValue="#000000"
                          label="Color"
                          name={["backgroundOptions", "color"]}
                        >
                          <ColorPicker
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {(backgroundOptionsColorType === "color-gradient" ||
                      backgroundOptionsStanColorType == "color-gradient") && (
                      <>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue="linear"
                            label="Gradient Type"
                            name={["backgroundOptions", "gradient", "type"]}
                          >
                            <Radio.Group
                              defaultValue={"linear"}
                              optionType="button"
                              buttonStyle="solid"
                            >
                              <Radio.Button value="linear">Linear</Radio.Button>
                              <Radio.Button value="radial">Radial</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="0"
                            name={[
                              "backgroundOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"0"} value={"0"} />
                          </Form.Item>
                          <Form.Item
                            initialValue="#000000"
                            label="Dots Gradient"
                            name={[
                              "backgroundOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="1"
                            name={[
                              "backgroundOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"1"} value={"1"} />
                          </Form.Item>
                          <Form.Item
                            label=" "
                            initialValue="#000000"
                            name={[
                              "backgroundOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue={0}
                            label="Rotation"
                            name={["backgroundOptions", "gradient", "rotation"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>

                <Card
                  className="card-settingt-srabble"
                  title={<strong>Dots Options</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="square"
                        label="Dots Style"
                        name={["dotsOptions", "type"]}
                      >
                        <Select
                          options={[
                            {
                              label: "Square",
                              value: "square",
                            },
                            {
                              label: "Dots",
                              value: "dots",
                            },
                            {
                              label: "Rounded",
                              value: "rounded",
                            },
                            {
                              label: "Classy",
                              value: "classy",
                            },
                            {
                              label: "Classy Rounded",
                              value: "classy-rounded",
                            },
                            {
                              label: "Extra Rounded",
                              value: "extra-rounded",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="single-color"
                        label="Color Type"
                        name={["dotsOptions", "colorType"]}
                      >
                        <Radio.Group
                          defaultValue={"single-color"}
                          optionType="button"
                          buttonStyle="solid"
                        >
                          <Radio.Button value="single-color">
                            Single color
                          </Radio.Button>
                          <Radio.Button value="color-gradient">
                            Color gradient
                          </Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {(colorType === "single-color" ||
                      stanColorType == "single-color") && (
                      <Col
                        span={8}
                        style={{
                          paddingRight: 5,
                          overflow: "hidden",
                        }}
                      >
                        <Form.Item
                          initialValue="#000000"
                          label="Color"
                          name={["dotsOptions", "color"]}
                        >
                          <ColorPicker
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {(colorType === "color-gradient" ||
                      stanColorType == "color-gradient") && (
                      <>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue="linear"
                            label="Gradient Type"
                            name={["dotsOptions", "gradient", "type"]}
                          >
                            <Radio.Group
                              defaultValue={"linear"}
                              optionType="button"
                              buttonStyle="solid"
                            >
                              <Radio.Button value="linear">Linear</Radio.Button>
                              <Radio.Button value="radial">Radial</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="0"
                            name={[
                              "dotsOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"0"} value={"0"} />
                          </Form.Item>
                          <Form.Item
                            initialValue="#000000"
                            label="Dots Gradient"
                            name={[
                              "dotsOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="1"
                            name={[
                              "dotsOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"1"} value={"1"} />
                          </Form.Item>
                          <Form.Item
                            label=" "
                            initialValue="#000000"
                            name={[
                              "dotsOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue={0}
                            label="Rotation"
                            name={["dotsOptions", "gradient", "rotation"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>

                <Card
                  className="card-settingt-srabble"
                  title={<strong>Corners Square Options</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="square"
                        label="Corners Square Style"
                        name={["cornersSquareOptions", "type"]}
                      >
                        <Select
                          options={[
                            {
                              label: "Square",
                              value: "square",
                            },
                            {
                              label: "Dots",
                              value: "dots",
                            },
                            {
                              label: "Rounded",
                              value: "rounded",
                            },
                            {
                              label: "Classy",
                              value: "classy",
                            },
                            {
                              label: "Classy Rounded",
                              value: "classy-rounded",
                            },
                            {
                              label: "Extra Rounded",
                              value: "extra-rounded",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="single-color"
                        label="Color Type"
                        name={["cornersSquareOptions", "colorType"]}
                      >
                        <Radio.Group
                          defaultValue={"single-color"}
                          optionType="button"
                          buttonStyle="solid"
                        >
                          <Radio.Button value="single-color">
                            Single color
                          </Radio.Button>
                          <Radio.Button value="color-gradient">
                            Color gradient
                          </Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {(cornersSquareOptionsColorType === "single-color" ||
                      cornersSquareOptionsStanColorType == "single-color") && (
                      <Col
                        span={8}
                        style={{
                          paddingRight: 5,
                          overflow: "hidden",
                        }}
                      >
                        <Form.Item
                          initialValue="#000000"
                          label="Color"
                          name={["cornersSquareOptions", "color"]}
                        >
                          <ColorPicker
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {(cornersSquareOptionsColorType === "color-gradient" ||
                      cornersSquareOptionsStanColorType ==
                        "color-gradient") && (
                      <>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue="linear"
                            label="Gradient Type"
                            name={["cornersSquareOptions", "gradient", "type"]}
                          >
                            <Radio.Group
                              defaultValue={"linear"}
                              optionType="button"
                              buttonStyle="solid"
                            >
                              <Radio.Button value="linear">Linear</Radio.Button>
                              <Radio.Button value="radial">Radial</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="0"
                            name={[
                              "cornersSquareOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"0"} value={"0"} />
                          </Form.Item>
                          <Form.Item
                            initialValue="#000000"
                            label="Dots Gradient"
                            name={[
                              "cornersSquareOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="1"
                            name={[
                              "cornersSquareOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"1"} value={"1"} />
                          </Form.Item>
                          <Form.Item
                            label=" "
                            initialValue="#000000"
                            name={[
                              "cornersSquareOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue={0}
                            label="Rotation"
                            name={[
                              "cornersSquareOptions",
                              "gradient",
                              "rotation",
                            ]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>

                <Card
                  className="card-settingt-srabble"
                  title={<strong>Corners Dot Options</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="square"
                        label="Corners Square Style"
                        name={["cornersDotOptions", "type"]}
                      >
                        <Select
                          options={[
                            {
                              label: "Square",
                              value: "square",
                            },
                            {
                              label: "Dots",
                              value: "dots",
                            },
                            {
                              label: "Rounded",
                              value: "rounded",
                            },
                            {
                              label: "Classy",
                              value: "classy",
                            },
                            {
                              label: "Classy Rounded",
                              value: "classy-rounded",
                            },
                            {
                              label: "Extra Rounded",
                              value: "extra-rounded",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="single-color"
                        label="Color Type"
                        name={["cornersDotOptions", "colorType"]}
                      >
                        <Radio.Group
                          defaultValue={"single-color"}
                          optionType="button"
                          buttonStyle="solid"
                        >
                          <Radio.Button value="single-color">
                            Single color
                          </Radio.Button>
                          <Radio.Button value="color-gradient">
                            Color gradient
                          </Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {(cornersDotOptionsColorType === "single-color" ||
                      cornersDotOptionsStanColorType == "single-color") && (
                      <Col
                        span={8}
                        style={{
                          paddingRight: 5,
                          overflow: "hidden",
                        }}
                      >
                        <Form.Item
                          initialValue="#000000"
                          label="Color"
                          name={["cornersDotOptions", "color"]}
                        >
                          <ColorPicker
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {(cornersDotOptionsColorType === "color-gradient" ||
                      cornersDotOptionsStanColorType == "color-gradient") && (
                      <>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue="linear"
                            label="Gradient Type"
                            name={["cornersDotOptions", "gradient", "type"]}
                          >
                            <Radio.Group
                              defaultValue={"linear"}
                              optionType="button"
                              buttonStyle="solid"
                            >
                              <Radio.Button value="linear">Linear</Radio.Button>
                              <Radio.Button value="radial">Radial</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="0"
                            name={[
                              "cornersDotOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"0"} value={"0"} />
                          </Form.Item>
                          <Form.Item
                            initialValue="#000000"
                            label="Dots Gradient"
                            name={[
                              "cornersDotOptions",
                              "gradient",
                              "colorStops",
                              "0",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            style={{
                              display: "none",
                            }}
                            initialValue="1"
                            name={[
                              "cornersDotOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "offset",
                            ]}
                          >
                            <Input defaultValue={"1"} value={"1"} />
                          </Form.Item>
                          <Form.Item
                            label=" "
                            initialValue="#000000"
                            name={[
                              "cornersDotOptions",
                              "gradient",
                              "colorStops",
                              "1",
                              "color",
                            ]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue={0}
                            label="Rotation"
                            name={["cornersDotOptions", "gradient", "rotation"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>

                <Card
                  className="card-settingt-srabble"
                  title={<strong>Border Radius</strong>}
                  bordered={false}
                  style={{ width: "100%" }}
                >
                  <Row>
                    <Col
                      span={24}
                      style={{
                        paddingRight: 5,
                      }}
                    >
                      <Form.Item
                        initialValue="square"
                        label="Color Type"
                        name={["shape"]}
                      >
                        <Radio.Group
                          defaultValue={"square"}
                          optionType="button"
                          buttonStyle="solid"
                        >
                          <Radio.Button value="square">Square</Radio.Button>
                          <Radio.Button value="circle">Circle</Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    {(shapeField === "circle" || shapeWatch == "circle") && (
                      <>
                        
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            label="Color"
                            initialValue="#000000"
                            name={["borderRadius", "color"]}
                          >
                            <ColorPicker
                              style={{
                                width: "100%",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                            display: "none",
                          }}
                        >
                          <Form.Item
                            initialValue={1}
                            label="Round"
                            name={["borderRadius", "round"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            initialValue={1}
                            label="Thickness"
                            name={["borderRadius", "thickness"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>

                        <Col
                          span={8}
                          style={{
                            paddingRight: 5,
                            overflow: "hidden",
                          }}
                        >
                          <Form.Item
                            label="Dasharray"
                            initialValue={0}
                            name={["borderRadius", "dasharray"]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>
              </Form>
            )}
          </div>
          <div
            style={{
              padding: 5,
            }}
            className={"body_modal_setting_item2"}
          >
            {imageURL && !loading ? (
              <img
                className="image-calendar-preview"
                width={"100%"}
                src={imageURL}
              />
            ) : (
              <>{loading && <Skeleton active />}</>
            )}
          </div>
        </div>
      </Modal>
      <Button
        style={{
          height: "35px",
          width: "100%",
          fontSize: "16px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        type="primary"
        onClick={showModel}
        icon={
          <AiFillSetting
            style={{
              marginRight: 3,
            }}
          />
        }
      >
        Setting
      </Button>
    </div>
  );
};

const QRLayerSettings = ({ layer }) => {
  return layer.imageqrcode ? <FormQRSetting layer={layer} /> : null;
};

export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(QRLayerSettings);
